import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack, Typography } from '@emburse/embark-core';
import { useEffect, useMemo, useState } from 'react';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { getGlobalDefLists, getUserDefList } from '../../api/audit';
import { AuditDefType } from '../../interfaces/Audit';
import CorpAuditConfigInvalidExpenseTypes from './CorpAuditConfigInvalidExpenseTypes';
import CorpAuditConfigExcessiveSpend from './CorpAuditConfigExcessiveSpend';
import CorpAuditConfigInvalidReceipts from './CorpAuditConfigInvalidReceipts';
import CorpAuditConfigQuestionableMerchants from './CorpAuditConfigQuestionableMerchants';
import CorpAuditConfigDrawer from './CorpAuditConfigDrawer';
import CorpAuditConfigDetectionRulesSkeleton from './CorpAuditConfigDetectionRulesSkeleton';
function CorpAuditConfigDetectionRules({ refreshPageloadData, pageloadData }) {
    useTranslation();
    const [drawerIsOpen, setDrawerIsOpen] = useState(false);
    const [globalAuditConfig, setGlobalAuditConfig] = useState(null);
    const [userAuditConfig, setUserAuditConfig] = useState(null);
    const [currentAuditDefinition, setCurrentAuditDefinition] = useState(null);
    useEffect(() => {
        (async () => {
            const requestedGlobalAuditConfig = await getGlobalDefLists();
            setGlobalAuditConfig(requestedGlobalAuditConfig);
            const requestedUserAuditConfig = await getUserDefList();
            setUserAuditConfig(requestedUserAuditConfig);
        })();
    }, []);
    const hasData = useMemo(() => {
        const hasPageloadData = pageloadData && pageloadData.AuditDefs && pageloadData.AuditDefs.length > 0;
        const hasGlobalAuditConfigData = globalAuditConfig;
        const hasUserAuditConfigData = userAuditConfig;
        return hasPageloadData && hasGlobalAuditConfigData && hasUserAuditConfigData;
    }, [pageloadData, globalAuditConfig, userAuditConfig]);
    return (_jsxs(Stack, { alignItems: "flex-start", sx: { width: '100%' }, spacing: 8, children: [_jsxs(Stack, { alignItems: "flex-start", sx: { width: '100%' }, spacing: 2, children: [_jsx(Typography, { variant: "h5", children: $t('Detection Rules') }), _jsx(Typography, { children: $t('Configure the rules InstantAudit will use to flag expenses submitted in your company.') })] }), !hasData ? (_jsx(CorpAuditConfigDetectionRulesSkeleton, {})) : (_jsxs(_Fragment, { children: [_jsx(CorpAuditConfigInvalidExpenseTypes, { data: hasData
                            ? pageloadData.AuditDefs.filter((auditDef) => auditDef.Type === AuditDefType.InvalidExpenseTypes)
                            : [], onEdit: (selectedAuditDefinition) => {
                            setCurrentAuditDefinition(selectedAuditDefinition);
                            setDrawerIsOpen(true);
                        } }), _jsx(CorpAuditConfigExcessiveSpend, { data: hasData
                            ? pageloadData.AuditDefs.filter((auditDef) => auditDef.Type === AuditDefType.ExcessiveSpend)
                            : [], onEdit: (selectedAuditDefinition) => {
                            setCurrentAuditDefinition(selectedAuditDefinition);
                            setDrawerIsOpen(true);
                        } }), _jsx(CorpAuditConfigInvalidReceipts, { data: hasData
                            ? pageloadData.AuditDefs.filter((auditDef) => auditDef.Type === AuditDefType.InvalidReceipts)
                            : [], onEdit: (selectedAuditDefinition) => {
                            setCurrentAuditDefinition(selectedAuditDefinition);
                            setDrawerIsOpen(true);
                        } }), _jsx(CorpAuditConfigQuestionableMerchants, { data: hasData
                            ? pageloadData.AuditDefs.filter((auditDef) => auditDef.Type === AuditDefType.InvalidMerchantCode)
                            : [], onEdit: (selectedAuditDefinition) => {
                            setCurrentAuditDefinition(selectedAuditDefinition);
                            setDrawerIsOpen(true);
                        } }), currentAuditDefinition !== null && (_jsx(CorpAuditConfigDrawer, { auditDefinition: currentAuditDefinition, drawerIsOpen: drawerIsOpen, setDrawerIsOpen: setDrawerIsOpen, globalAuditConfig: globalAuditConfig, onSave: refreshPageloadData }))] }))] }));
}
export default CorpAuditConfigDetectionRules;
